// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4163":"98724c4e","4873":"4d8d69d2","6903":"8bd1b193","9776":"8bd1b193"}[chunkId] + ".chunk.css";
};